import request from '@/utils/request'


// 查询学校批次列表
export function listSchoolBatch(query) {
  return request({
    url: '/biz/admin/school/batch/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询学校批次分页
export function pageSchoolBatch(query) {
  return request({
    url: '/biz/admin/school/batch/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询学校批次详细
export function getSchoolBatch(data) {
  return request({
    url: '/biz/admin/school/batch/detail',
    method: 'get',
    params: data
  })
}

export function getSchoolBatchQrcode(data) {
  return request({
    url: '/biz/admin/school/batch/qrcode',
    method: 'get',
    params: data
  })
}

// 新增学校批次
export function addSchoolBatch(data) {
  return request({
    url: '/biz/admin/school/batch/add',
    method: 'post',
    data: data
  })
}

// 修改学校批次
export function updateSchoolBatch(data) {
  return request({
    url: '/biz/admin/school/batch/edit',
    method: 'post',
    data: data
  })
}

// 删除学校批次
export function delSchoolBatch(data) {
  return request({
    url: '/biz/admin/school/batch/delete',
    method: 'post',
    data: data
  })
}


export function schoolBatchGradeList(data) {
  return request({
    url: '/biz/admin/school/batch/grade/list',
    method: 'post',
    data: data
  })
}


export function schoolBatchGradeSave(data) {
  return request({
    url: '/biz/admin/school/batch/grade/save',
    method: 'post',
    data: data
  })
}


export function schoolBatchGoodsList(data) {
  return request({
    url: '/biz/admin/school/batch/goods/list',
    method: 'post',
    data: data
  })
}


export function schoolBatchGoodsSave(data) {
  return request({
    url: '/biz/admin/school/batch/goods/save',
    method: 'post',
    data: data
  })
}